import React from "react";
export const IconEdit: React.FC = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M18.6342 0.605251C17.8283 -0.20175 16.5149 -0.20175 15.709 0.605251L15.2852 1.02211L19.0162 4.75249L19.3668 4.39976C19.775 3.99359 20 3.4538 20 2.87127C20 2.28873 19.775 1.74895 19.372 1.34278L18.6342 0.605251Z" />
      <path d="M13.4119 2.88729L17.1429 6.61765L18.268 5.50068L14.5369 1.77032L13.4119 2.88729Z" />
      <path d="M1.76871 14.49L0 20L5.5102 18.2043L16.3946 7.3659L12.6635 3.63553L1.76871 14.49Z" />
    </svg>
  );
};
export const IconDelete: React.FC = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M17.1872 1.47368H12.9091V1.43158C12.9091 0.631579 12.2674 0 11.4545 0H8.54545C7.73262 0 7.09091 0.631579 7.09091 1.43158V1.47368H2.81283C2.36364 1.47368 2 1.83158 2 2.27368V3.07368C2 3.51579 2.36364 3.87368 2.81283 3.87368H17.1872C17.6364 3.87368 18 3.51579 18 3.07368V2.27368C18 1.83158 17.6364 1.47368 17.1872 1.47368Z" />
      <path d="M16.1176 4.96841H3.88232C3.64702 4.96841 3.4759 5.15789 3.49729 5.38947L4.09622 17.5789C4.16039 18.9263 5.29408 20 6.66306 20H13.3155C14.6845 20 15.8181 18.9474 15.8823 17.5789L16.4812 5.38947C16.524 5.17894 16.3315 4.96841 16.1176 4.96841ZM8.67376 16.7368C8.67376 17.1158 8.37429 17.4105 7.98927 17.4105C7.60424 17.4105 7.30478 17.1158 7.30478 16.7368V8.25262C7.30478 7.87368 7.60424 7.57894 7.98927 7.57894C8.37429 7.57894 8.67376 7.87368 8.67376 8.25262V16.7368ZM12.6951 16.7368C12.6951 17.1158 12.3957 17.4105 12.0107 17.4105C11.6256 17.4105 11.3262 17.1158 11.3262 16.7368V8.25262C11.3262 7.87368 11.6256 7.57894 12.0107 7.57894C12.3957 7.57894 12.6951 7.87368 12.6951 8.25262V16.7368Z" />
    </svg>
  );
};
export const IconMore: React.FC = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12.1951 10.1429C12.1951 11.3333 11.2195 12.2857 10 12.2857C8.78049 12.2857 7.80488 11.3333 7.80488 10.1429C7.80488 8.95238 8.78049 8 10 8C11.2195 8 12.1951 8.95238 12.1951 10.1429ZM17.8049 8C16.5854 8 15.6098 8.95238 15.6098 10.1429C15.6098 11.3333 16.5854 12.2857 17.8049 12.2857C19.0244 12.2857 20 11.3333 20 10.1429C20 8.95238 19.0244 8 17.8049 8ZM2.19512 8C0.97561 8 0 8.95238 0 10.1429C0 11.3333 0.97561 12.2857 2.19512 12.2857C3.41463 12.2857 4.39024 11.3333 4.39024 10.1429C4.39024 8.95238 3.41463 8 2.19512 8Z" />
    </svg>
  );
};
export const IconSort: React.FC = () => {
  return (
    <svg
      width="8"
      height="11"
      viewBox="0 0 8 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4 11L0 6H8L4 11Z" fill="#7D90B2" />
      <path d="M4 0L0 5H8L4 0Z" fill="#7D90B2" />
    </svg>
  );
};
export const IconClose: React.FC = () => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9.08168 0.15774L5 4.23942L0.918317 0.15774C0.707997 -0.0525801 0.368061 -0.0525801 0.15774 0.15774C-0.0525801 0.368061 -0.0525801 0.707997 0.15774 0.918318L4.23942 5L0.15774 9.07924C-0.0525801 9.28956 -0.0525801 9.6295 0.15774 9.83982C0.368061 10.0501 0.707997 10.0501 0.918317 9.83982L5 5.75813L9.08168 9.83982C9.292 10.0501 9.63194 10.0501 9.84226 9.83982C10.0526 9.6295 10.0526 9.28956 9.84226 9.07924L5.76058 5L9.84226 0.918318C10.0526 0.707997 10.0526 0.368061 9.84226 0.15774C9.63194 -0.0525801 9.292 -0.0525801 9.08168 0.15774Z" />
    </svg>
  );
};
export const IconSearch: React.FC = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M13.4097 14.8822C11.7399 16.1799 9.63851 16.7922 7.53338 16.5942C5.42824 16.3963 3.47766 15.403 2.07881 13.8166C0.679961 12.2303 -0.0619809 10.1701 0.00405863 8.05565C0.0700982 5.94118 0.939153 3.9314 2.43427 2.43552C3.92939 0.939633 5.93814 0.0701341 8.05152 0.00406071C10.1649 -0.0620127 12.224 0.680308 13.8096 2.07987C15.3951 3.47944 16.3879 5.43102 16.5857 7.53723C16.7836 9.64345 16.1717 11.7459 14.8745 13.4166L19.6936 18.2201C20.1016 18.6267 20.1022 19.2872 19.695 19.6946C19.2878 20.1021 18.6273 20.1017 18.2204 19.6939L13.4201 14.8822H13.4097ZM8.31916 14.5495C9.13773 14.5495 9.94829 14.3882 10.7045 14.0748C11.4608 13.7614 12.148 13.302 12.7268 12.7229C13.3056 12.1438 13.7647 11.4563 14.078 10.6996C14.3913 9.94298 14.5525 9.13201 14.5525 8.31302C14.5525 7.49403 14.3913 6.68306 14.078 5.92641C13.7647 5.16976 13.3056 4.48225 12.7268 3.90314C12.148 3.32402 11.4608 2.86465 10.7045 2.55123C9.94829 2.23782 9.13773 2.07651 8.31916 2.07651C6.66598 2.07651 5.08051 2.73356 3.91153 3.90314C2.74256 5.07271 2.08583 6.659 2.08583 8.31302C2.08583 9.96705 2.74256 11.5533 3.91153 12.7229C5.08051 13.8925 6.66598 14.5495 8.31916 14.5495Z" />
    </svg>
  );
};
export const IconAdd: React.FC = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11 9H15V11H11V15H9V11H5V9H9V5H11V9ZM10 20C7.34784 20 4.8043 18.9464 2.92893 17.0711C1.05357 15.1957 0 12.6522 0 10C0 7.34784 1.05357 4.8043 2.92893 2.92893C4.8043 1.05357 7.34784 0 10 0C12.6522 0 15.1957 1.05357 17.0711 2.92893C18.9464 4.8043 20 7.34784 20 10C20 12.6522 18.9464 15.1957 17.0711 17.0711C15.1957 18.9464 12.6522 20 10 20ZM10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18Z" />
    </svg>
  );
};
export const IconNext: React.FC = () => {
  return (
    <svg
      width="6"
      height="10"
      viewBox="0 0 6 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0.200293 1.10636C-0.428118 0.51287 0.566865 -0.426818 1.19528 0.216126L5.80362 4.51891C6.06546 4.7662 6.06546 5.21131 5.80362 5.4586L1.19528 9.81084C0.566865 10.4043 -0.428118 9.46464 0.200293 8.87115L4.28496 5.01348L0.200293 1.10636Z" />
    </svg>
  );
};
export const IconPrev: React.FC = () => {
  return (
    <svg
      width="6"
      height="10"
      viewBox="0 0 6 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.79971 1.10636C6.42812 0.51287 5.43313 -0.426818 4.80472 0.216126L0.196378 4.51891C-0.0654595 4.7662 -0.0654595 5.21131 0.196378 5.4586L4.80472 9.81084C5.43313 10.4043 6.42812 9.46464 5.79971 8.87115L1.71504 5.01348L5.79971 1.10636Z"
      />
    </svg>
  );
};
